import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getRideDetails } from '../api/services/Rides';
import { RideDetails } from '../types/rides';

interface IUseRideDetailsQuery {
  rideSlug: string;
}

export const RIDE_DETAILS_QUERY_KEY = 'rideDetails';

export const useRideDetailsQuery = ({ rideSlug }: IUseRideDetailsQuery) => {
  return useApiGet<{ data: RideDetails }>([RIDE_DETAILS_QUERY_KEY, rideSlug], () => getRideDetails(rideSlug), {
    enabled: true,
  });
};
